function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5143722,2 L24.8290469,2 L24.8290469,39.0344308 L61.9849115,39.0344308 L61.9849115,11.6355868 C62,6.43327469 57.7337368,2 52.5143722,2 Z",
  fill: "#333745",
  fillRule: "nonzero"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3267776,2 L11.6822995,2 C6.46293495,2 2,6.23724554 2,11.650666 L2,16.2799698 L16.3267776,16.2799698 L16.3267776,2 Z",
  fill: "#333745",
  fillRule: "nonzero"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#333745",
  fillRule: "nonzero",
  points: "2 24.9504901 16.3267776 24.9504901 16.3267776 39.2304599 2 39.2304599"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6732224,61.9849208 L52.3177005,61.9849208 C57.5370651,61.9849208 62,57.7476753 62,52.3342548 L62,47.7200302 L47.6732224,47.7200302 L47.6732224,61.9849208 Z",
  fill: "#333745",
  fillRule: "nonzero"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#333745",
  fillRule: "nonzero",
  points: "24.8290469 47.7200302 39.1558245 47.7200302 39.1558245 62 24.8290469 62"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M2,47.7200302 L2,52.349334 C2,57.5516461 6.25113464,62 11.6822995,62 L16.3267776,62 L16.3267776,47.7200302 L2,47.7200302 Z",
  fill: "#333745",
  fillRule: "nonzero"
});

var SvgLedger = function SvgLedger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLedger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ledger.bb455fc7.svg";
export { ForwardRef as ReactComponent };